import { Link, useLocation } from "react-router-dom";
import LanguageToggle from "./LanguageToggle";

/**
 * Slim shared legal footer.
 *
 * Renders below the BottomNav on every "main" app screen
 * (Home / Places / Map / Journey / Settings / Tips / Friends / etc).
 *
 * Hidden on:
 *   - Admin / Business / Vendor dashboards (those have their own chrome)
 *   - Legal pages themselves (Privacy / Terms / LegalPage)
 *   - The marketing Landing page (already has its own footer)
 *   - The auth callback page
 *
 * Anchor sits *above* the fixed BottomNav (h-16 + safe-area inset).
 */
export default function LegalFooter({ force = false }) {
  const { pathname, hash } = useLocation();

  // Hide on routes that already have their own footer / no chrome needed.
  if (
    !force && (
      pathname.startsWith("/admin") ||
      pathname.startsWith("/business") ||
      pathname.startsWith("/vendor") ||
      pathname === "/" ||                // marketing landing OR home (handled by Home itself — see below)
      pathname === "/privacy" ||
      pathname === "/terms" ||
      pathname === "/share" ||
      pathname === "/login" ||           // splash has inline links
      pathname.startsWith("/onboarding") ||
      hash.includes("session_id=")
    )
  ) {
    return null;
  }

  return (
    <div
      data-testid="legal-footer"
      className="w-full text-center"
      style={{
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 110px)",
        paddingTop: 18,
        fontSize: 10,
        letterSpacing: "0.18em",
        color: "rgba(241,236,222,0.32)",
        background: "transparent",
        textTransform: "uppercase",
      }}
    >
      <div className="inline-flex flex-col items-center gap-2">
        <div className="inline-flex items-center gap-2">
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="hover:text-gold transition-colors"
          >
            Privacy
          </Link>
          <span className="text-foreground/25">·</span>
          <Link
            to="/terms"
            data-testid="footer-link-terms"
            className="hover:text-gold transition-colors"
          >
            Terms
          </Link>
          <span className="text-foreground/25">·</span>
          <span data-testid="footer-copyright">© 2025 Habano App LLC</span>
        </div>
      </div>
    </div>
  );
}
